import { pushEvent } from './dataLayer';
import { logger } from 'logging';
import {
  DEFAULT_LLM_REFERRER_CONFIG,
  LLM_SOURCE_EVENT,
} from 'store/remoteConfig/constants';

// Error/Info log messages
const LOG_REFERRER_PARSE_ERROR = 'Error parsing referrer URL for LLM tracking';
const LOG_TRACKING_ERROR = 'Error tracking LLM source acquisition';

/**
 * Extracts LLM platform from referrer URL using provided patterns
 */
const getLLMPlatformFromReferrer = (
  referrer: string,
  patterns: Record<string, string>
): string | null => {
  if (!referrer) return null;

  try {
    const referrerUrl = new URL(referrer);
    const hostname = referrerUrl.hostname.toLowerCase();

    for (const [pattern, platform] of Object.entries(patterns)) {
      if (hostname === pattern || hostname.endsWith(`.${pattern}`)) {
        return platform;
      }
    }
  } catch (error) {
    logger.info(LOG_REFERRER_PARSE_ERROR, error);
  }

  return null;
};

/**
 * Detects and tracks user traffic originating from LLM platforms
 * @param patterns - Mapping of referrer hostname to platform name
 */
export const trackLLMSourceAcquisition = (
  patterns: Record<string, string> = DEFAULT_LLM_REFERRER_CONFIG.patterns
): void => {
  // SSR safety check
  if (typeof document === 'undefined') return;

  try {
    const referrer = document.referrer;
    const llmPlatform = getLLMPlatformFromReferrer(referrer, patterns);
    if (!llmPlatform) return;

    pushEvent(LLM_SOURCE_EVENT, { llmPlatform });
  } catch (error) {
    logger.info(LOG_TRACKING_ERROR, error);
  }
};
